/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Road_Dude_Prompt_TitleInputs */

const en_road_dude_prompt_title = /** @type {(inputs: Road_Dude_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cast your own driver.`)
};

const zh_road_dude_prompt_title = /** @type {(inputs: Road_Dude_Prompt_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`给你的短片选一位司机。`)
};

/**
* | output |
* | --- |
* | "Cast your own driver." |
*
* @param {Road_Dude_Prompt_TitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const road_dude_prompt_title = /** @type {((inputs?: Road_Dude_Prompt_TitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Road_Dude_Prompt_TitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_road_dude_prompt_title(inputs)
	return zh_road_dude_prompt_title(inputs)
});
export { road_dude_prompt_title as "road_dude.prompt.title" }